// Loaded independently of promotion cards so AJAX-only slots can initialize.
  function initPromoSlotsPopup() {
    const promoSlot = document.querySelectorAll('.promotion-slot.popup');
    promoSlot.forEach((slot) => {
        if (!slot?.dataset?.init){
            const popup = slot.querySelector('.promotion-products-wrapper');
            if (!popup) return;
            slot.dataset.init = true;
            slot.addEventListener('click', (e) => {
                e.preventDefault();
                popup.classList.remove('hidden');
            });
            const closeBtn = popup.querySelector('.promotion-products-popup-header-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                popup.classList.add('hidden');
                });
            }

            const addAll = slot.querySelector(".promotion-products-popup-add-all");
            if (addAll) {
                addAll.addEventListener("click",()=>{
                    const items = [];
                    slot?.querySelectorAll(".promotion-products-wrapper .promotion-products-popup-content-list-item").forEach(el=>{
                        const defaultVariantId = el.dataset.defaultVariantId;
                        items.push({
                            quantity: 1,
                            id: defaultVariantId,
                        })  
                    })
                    window.enrouteCart?.addToCart?.({ items });
                })
            }
            
        }
      
    });
  }
  if (!window._erj_?.initPromoSlotsPopup) {
    window._erj_ = window._erj_ || {};
    window._erj_.initPromoSlotsPopup = initPromoSlotsPopup;
  }
  document.addEventListener('DOMContentLoaded', function (e) {
    initPromoSlotsPopup();
  });
